var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.89 18.652-3.794-3.793a.37.37 0 0 0-.265-.11h-.413A6.499 6.499 0 0 0 10.5 4 6.5 6.5 0 0 0 4 10.5a6.499 6.499 0 0 0 10.75 4.92v.412c0 .1.04.193.109.265l3.793 3.794a.375.375 0 0 0 .532 0l.706-.706a.375.375 0 0 0 0-.532zM10.5 15.5c-2.763 0-5-2.237-5-5 0-2.762 2.237-5 5-5a5 5 0 0 1 5 5c0 2.763-2.238 5-5 5z",
    fill: "currentColor"
  })));
};

export default SvgSearch;